import { render, staticRenderFns } from "./VerDetalleTipoDispositivoModal.vue?vue&type=template&id=8760907c&"
import script from "./VerDetalleTipoDispositivoModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleTipoDispositivoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports